import { Button } from "antd";
import "./LogoCard.scss";
import { LogoDto } from "../../domain/BrandDataDto";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { DeleteOutlined } from "@ant-design/icons";
import ADAIcon from "../icons/ADAIcon";

export interface LogoCardMenuProps {
  logo: LogoDto;
  editAltText: (logo: LogoDto) => void;
  deleteLogo: (logo: LogoDto) => void;
  closeMenu: () => void;
}

export default function LogoCardMenu({
  logo,
  editAltText,
  deleteLogo,
  closeMenu
}: LogoCardMenuProps) {
  const ref = useRef(null);

  const handleClickOutside = (ev: MouseEvent) => {
    closeMenu();
  }

  useOnClickOutside(ref, (ev) => handleClickOutside(ev as MouseEvent));

  function onAltTextClick() {
    closeMenu();
    editAltText(logo);
  }

  function onDeleteClick() {
    closeMenu();
    deleteLogo(logo);
  }

  return (
    <div className={"ops-menu"} ref={ref}>
      <ul>
        <li className="round-top">
          <Button type={"link"} onClick={() => onAltTextClick()}>
            <ADAIcon color={"#000"} /> ADA Text
          </Button>
        </li>
        <li>
          <Button type={"link"} onClick={() => onDeleteClick()}>
            <DeleteOutlined /> Delete
          </Button>
        </li>
      </ul>
    </div>
  );
}
